<template>
	<div>
		<div v-if="phone" class="home_page" @click="foothide()">
			<video id="my_video" loop class=" video-js vjs-default-skin vjs-fluid " autoplay preload="auto" width="100%" poster="../assets/background.jpg" data-setup="{}">
				<source src="" type='video/mp4'>
				<source src="../assets/company_profile.mp4" type='video/mp4'>
	        您的浏览器版本过低不支持 video 标签。
			</video>
			<div class="swiper-container">
			    <div class="swiper-wrapper" id="swiper-wrapper">
		        <div id="swiper-slide-0" class="swiper-slide">
		          <div class="investpro newhand_slide">
		            <router-link class="home-link" to="company-profile"><img src="../assets/logo_first.png" alt=""></router-link>
		          </div>
		        </div>
		        <div id="swiper-slide-1" class="swiper-slide">
		          <div class="investpro sxm_slide">
		            <router-link class="home-link" to="ayo-about"><img src="../assets/ayo_icon_2.png" alt=""></router-link>
		          </div>
		        </div>
		        <div id="swiper-slide-2" class="swiper-slide">
		          <div class="investpro hrplan_slide">
		            <router-link class="home-link" to="afsc-about"><img src="../assets/afsc_icon_2.png" alt=""></router-link>
		          </div>
		        </div>
		    </div>
		    <!-- Add Pagination -->
		    <div class="swiper-pagination"></div>
	      <div id="swiper-pagination1" class="swiper-pagination1"></div>
		    <!-- Add Arrows -->
		  </div>
	  	<div class="home_footer" id="person_1">
	      <p v-if="lang">派嗨拜浪 ( 上海 ) 网络科技有限公司版权所有©2016【 沪ICP备16032276号 】</p>
	      <p v-else class="english">PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD. All rights reserved©2016[Shanghai ICP no. 16032276]</p>
	      <p v-if="lang">本网站由派嗨拜浪 ( 上海 ) 网络科技有限公司提供</p>
	      <p v-else class="english">This website is provided by PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD</p>
	  	</div>
	    <transition name="mybox">
	      <div  class="footer" v-show="fot_show"  @click.stop="footShow()">
	        <div><span v-if="lang">邮箱：</span><span v-else class="english">email: </span><span class="english">fxh@fangxuehai.cc</span></div>
	        <div>
	          <span v-if="lang">地址：上海市 杨浦区 军工路 100号 18栋 放学嗨</span>
	          <span v-else class="english">address: Afterschool, Building 18，No. 100, Jungong Road, Yangpu District, Shanghai</span>
	        </div>
	        <div v-on:click="link_to()" class="link_to">
	          <img src="../assets/sina_logo.png" alt="">
	          <span v-if="lang"> 放学嗨</span>
	          <span v-else class="english"> Afterschool</span>
	        </div>
	        <div>
	          <div>
	            <p><img src="../assets/wx_fxh.jpg" alt=""></p>
	            <p><img src="../assets/wx_logo.png" alt=""><span v-if="lang"> 放学嗨</span>
	          <span v-else class="english"> Afterschool</span></p>
	          </div>
	          <div>
	            <p><img src="../assets/wx_afsc.jpg" alt=""></p>
	            <p><img src="../assets/wx_logo.png" alt=""><span class="english"> AFSC</span></p>
	          </div>
	        </div>
	        <div class="home_footer">
	          <p v-if="lang">派嗨拜浪 ( 上海 ) 网络科技有限公司版权所有©2016【 沪ICP备16032276号 】</p>
	          <p v-else class="english">PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD. All rights reserved©2016[Shanghai ICP no. 16032276]</p>
	          <p v-if="lang">本网站由派嗨拜浪 ( 上海 ) 网络科技有限公司提供</p>
	          <p v-else class="english">This website is provided by PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD</p>
	        </div>
	      </div>
	    </transition>
	    <div id="click_btn" @click.stop="footShow()" class="phone_us" :style="{border: '2px solid #' + bordercolor,backgroundColor: '#' + bgcolor,color: '#' + bordercolor}">
	      <span v-if="lang">联系我们</span>
	      <span v-else class="english">Contact us</span><span :style="{backgroundColor:'#'+bordercolor}"></span>
	    </div>
	  </div>
	  <div v-else>
	  	<phone_home  :lang="lang"></phone_home>
	  </div>
	</div>
  
</template>

<script>
import videojs from 'video.js'
//import Swiper from 'swiper'
import 'video.js/dist/video-js.css'
import 'swiper/dist/css/swiper.min.css'
import phone_home from './phone_home'

export default {
  name: 'HomePage',
  components: {
  	phone_home,
  },
  props:["lang"],
  data () {
    return {
      msg: '11',
      ost_top: '',
      person_top: '',
      bordercolor: 'FFFB00',
      bgcolor: '000000',
      fot_show: false,
      scrollTop: 0,
      flag: true,
      phone: true
    }
  },
  methods: {
    handleScroll () {
      this.scrollTop = window.pageYOffset  //用于FF
            || document.documentElement.scrollTop
            || document.body.scrollTop
            || 0;
      this.ost_top = document.body.scrollTop + document.getElementById('click_btn').offsetTop
      this.person_top = document.getElementById('person_1').offsetTop
      if ( this.flag == true  ) {
        if ( this.ost_top > this.person_top ) {
          this.bordercolor = '000000'
          this.bgcolor = 'FFFB00'
        }else {
          this.bordercolor = 'FFFB00'
          this.bgcolor = '000000'
        }
      }
    },
    footShow () {
      this.fot_show = !this.fot_show;;
      this.flag = false;
      if ( this.fot_show == false ) {
        if ( this.ost_top > this.person_top ) {
          this.bordercolor = '000000'
          this.bgcolor = 'FFFB00'
        }else {
          this.bordercolor = 'FFFB00'
          this.bgcolor = '000000'
          setTimeout(() => {
            this.bordercolor = 'FFFB00'
            this.bgcolor = '000000'
          },200);
        }
        this.flag = true;
      }else {
        setTimeout(() => {
          this.bordercolor = '000000'
          this.bgcolor = 'FFFB00'
        },200);
      }
    },
    foothide () {
      this.fot_show = false;
      this.flag = true;
      this.bordercolor = 'FFFB00'
      this.bgcolor = '000000'
      this.ost_top = document.getElementById('click_btn').offsetTop + this.scrollTop
      this.person_top = document.getElementById('person_1').offsetTop
      if ( this.ost_top > this.person_top ) {
        this.bordercolor = '000000'
        this.bgcolor = 'FFFB00'
      }else {
        this.bordercolor = 'FFFB00'
        this.bgcolor = '000000'
        setTimeout(() => {
          this.bordercolor = 'FFFB00'
          this.bgcolor = '000000'
        },200);
      }
    },
    link_to () {
      window.location.href="https://weibo.com/u/5692890069?refer_flag=1001030101_&is_hot=1"
    },
    IsPC () {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  mounted () {
    
    this.phone = this.IsPC();
    if ( this.phone == true ) {
    	document.getElementById('ayo_icon').style.display = "inline-block";
	    document.getElementById('ayo_icon_2').style.display = "none";
	    document.getElementById('afsc_icon').style.display = "inline-block";
	    document.getElementById('afsc_icon_2').style.display = "none";
	  	videojs(document.getElementById('my_video'));
	  	var swiper = new Swiper('.swiper-container', {
	      slidesPerView: 1,
	      centeredSlides: true,
	      autoplay: {
	        delay: 4000,
	        disableOnInteraction: false
	      },
	      loop: true,
	      pagination: {
	        el: '.swiper-pagination',
	        type: 'fraction',
	        renderFraction: function (currentClass, totalClass) {
	          return `
	              <span class="ago">0<span class="${currentClass}"></span></span>
	              /
	              <span class="after">0<span class="${totalClass}"></span></span>
	          `
	        }
	      },
	      on: {
	        init: function() {
	          console.log(this)
	          // var len = swiper.slides.length;
	          var sp = document.getElementById('swiper-pagination1');
	          var html =[]
	          for (var i=0;i<3;i++){
	            let template = `<div id="pa-item-${i}" class="pa-item"></div>`;
	            html.push(template)
	            // sp.appendChild(`<span class="pa-item"><span>`)
	            sp.innerHTML = html.join('')
	          }
	          document.getElementById('pa-item-2').onclick = function(){
	            var box = document.getElementById('swiper-slide-2');
	            var contentwidth = parseInt(window.getComputedStyle(box).width)*0;
	            console.log(contentwidth);
	            document.getElementById('swiper-wrapper').setAttribute('style','transform:translate3d(-' + contentwidth + 'px, 0px, 0px);');
	            box.classList.add('swiper-slide-active');
	            console.dir(box);
	            document.getElementsByClassName('ago')[0].innerHTML = '0<span class="swiper-pagination-current">3</span>';
	            var item_lists = document.getElementsByClassName('pa-item');
	            for (let j = 0; j < item_lists.length; j++) {
	              item_lists[j].classList.remove("pa-item-active");
	            }
	            setTimeout(() => {
	              document.getElementById('pa-item-2').classList.add("pa-item-active");
	              box.classList.add('swiper-slide-active');
	            },100);
	          }
	          document.getElementById('pa-item-1').onclick = function(){
	            var box = document.getElementById('swiper-slide-1');
	            var contentwidth = parseInt(window.getComputedStyle(box).width)*2;
	            console.log(contentwidth);
	            document.getElementById('swiper-wrapper').setAttribute('style','transform:translate3d(-' + contentwidth + 'px, 0px, 0px);');
	            box.classList.add('swiper-slide-active');
	            console.dir(box);
	            document.getElementsByClassName('ago')[0].innerHTML = '0<span class="swiper-pagination-current">2</span>';
	            var item_lists = document.getElementsByClassName('pa-item');
	            for (let j = 0; j < item_lists.length; j++) {
	              item_lists[j].classList.remove("pa-item-active");
	            }
	            setTimeout(() => {
	              document.getElementById('pa-item-1').classList.add("pa-item-active");
	              box.classList.add('swiper-slide-active');
	            },100);
	          }
	          document.getElementById('pa-item-0').onclick = function(){
	            var box = document.getElementById('swiper-slide-0');
	            var contentwidth = parseInt(window.getComputedStyle(box).width)*1;
	            console.log(contentwidth);
	            document.getElementById('swiper-wrapper').setAttribute('style','transform:translate3d(-' + contentwidth + 'px, 0px, 0px);');
	            box.classList.add('swiper-slide-active');
	            console.dir(box);
	            document.getElementsByClassName('ago')[0].innerHTML = '0<span class="swiper-pagination-current">1</span>';
	            var item_lists = document.getElementsByClassName('pa-item');
	            for (let j = 0; j < item_lists.length; j++) {
	              item_lists[j].classList.remove("pa-item-active");
	            }
	            setTimeout(() => {
	              document.getElementById('pa-item-0').classList.add("pa-item-active");
	            },100);
	          }
	          var list = document.getElementsByClassName('pa-item');
	          list[0].classList.add("pa-item-active");
	        },
	        slideChangeTransitionStart: function() {
	          // console.log(this.activeIndex);
	          var item_lists = document.getElementsByClassName('pa-item');
	          switch (this.activeIndex) {
	            case 0:
	              for (let j = 0; j < item_lists.length; j++) {
	                item_lists[j].classList.remove("pa-item-active");
	              }
	              document.getElementById('pa-item-2').classList.add("pa-item-active");
	              break;
	            case 1:
	              for (let j = 0; j < item_lists.length; j++) {
	                item_lists[j].classList.remove("pa-item-active");
	              }
	              if ( document.getElementById('pa-item-0') ) {
	              	document.getElementById('pa-item-0').classList.add("pa-item-active");
	              }
	              break;
	            case 2:
	              for (let j = 0; j < item_lists.length; j++) {
	                item_lists[j].classList.remove("pa-item-active");
	              }
	              if ( document.getElementById('pa-item-1') ) {
	              	document.getElementById('pa-item-1').classList.add("pa-item-active");
	              }
	              break;
	            case 3:
	              for (let j = 0; j < item_lists.length; j++) {
	                item_lists[j].classList.remove("pa-item-active");
	              }
	              document.getElementById('pa-item-2').classList.add("pa-item-active");
	              break;
	            case 4:
	              for (let j = 0; j < item_lists.length; j++) {
	                item_lists[j].classList.remove("pa-item-active");
	              }
	              document.getElementById('pa-item-0').classList.add("pa-item-active");
	              break;
	          }
	        }
	      }
	    });
	    this.ost_top = document.getElementById('click_btn').offsetTop
	    console.log(this.ost_top);
	    window.addEventListener('scroll', this.handleScroll)
    }else {
    	
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

	.home_page {
		width: 100%;
  	min-width: 1500px;
	}

	.my_video-dimensions {
		width: 100%;
	}

	.home_footer {
		width: 100%;
		background-color: #FFFB00;
		padding-top: 20px;
		padding-bottom: 20px;
		p {
			margin: 0;
			width: 100%;
			color: #000000;
			font-family: Regular;
			font-size: 12px;
			text-align: center;
		}
	}
  .swiper-slide {
    width: 50%;
    text-align: center;
    font-size: 18px;
    background: transparent;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    img {
      width: 60%;
    }
  }
  .swiper-container {
    width: 70%;
    height: 100%;
    position: absolute;
    top: 0;
    margin-left: 15%;
    overflow: hidden;
  }
  .swiper-slide .investpro {
    width: 30%;
    margin-top: 0.58rem;
    margin-left: 0.19rem;
    -webkit-transition: all 0.5s linear;
    img {
      margin-top: 10px;
    }
  }
  .swiper-slide-active .investpro {
    width: 100%;
    margin-left: -.08rem;
    margin-top: .12rem;
    img {
      margin-bottom: 50px;
    }
  }
  .swiper-slide-active .sxm_slide {
    width: 50%;
  }

  .swiper-pagination {
    width: auto;
    right: 0;
    color: #FFFB00;
    bottom: 20%;
    text-align: right;
    padding-right: 18px;
  }


  .phone_us {
    position: fixed;
    bottom: 100px;
    left: 160px;
    text-align: left;
    width: 100px;
    padding-left: 3px;
    font-family: Regular;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    z-index: 100;
    &:hover {
      cursor: pointer;
    }
    span:nth-child(2) {
      display: inline-block;
      width: 3px;
      height: 3px;
      margin-left: 35px;
      margin-bottom: 1.5px;
      vertical-align: middle;
      border-radius: 50%;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 380px;
    background: #FFFB00;
    padding-top: 10px;
    z-index: 100;
    p {
      margin: 0;
    }
    &>div:nth-child(-n+3) {
      color: #000000;
      margin-top: 20px;
      margin-bottom: 20px;
      height: 20px;
      line-height: 20px;
      font-family: Heavy;
    }
    &>div:nth-child(3) {
      span {
        display: inline-block;
        padding-top: 5px;
        vertical-align: top;
      }
    }
    &>div:nth-child(4) {
      display: flex;
      margin-top: 40px;
      margin-bottom: 40px;
      justify-content: center;
      &>div:first-child {
        margin-right: 80px;
      }
      span {
        color: #000000;
        display: inline-block;
        font-family: Heavy;
        vertical-align: top;
      }
    }
  }

  .swiper-pagination1 {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 15px;
    z-index: 100;
  }

  .mybox-leave-active,.mybox-enter-active{
      transition:  all 1s ease;
  }

  .mybox-leave-active,.mybox-enter{
      height:0px !important;
  }

  .mybox-leave,.mybox-enter-active {
      height: 380px;
  }


</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue